import i18n from '@ps/lang'
const initState = () => ({
  url: '',
  duration: 0,
  clipStartTime: 0,
  clipEndTime: 0,
  volume: 100,
  onCutter: null,
  loading: false,
  desPath: '',
  title: ''
})
export default {
  namespaced: true,

  state: {
    dialog: {
      visible: false,
      appendToBody: true
    },
    ...initState()
  },

  mutations: {
    openDialog(state, config = {}) {
      if (!config.url) throw new Error(i18n.t('workbench.audio.audioEditor.argumentsAreEmpty'))
      Object.keys(config).forEach((key) => {
        state[key] = config[key]
      })
      state.dialog.visible = true
    },

    closeDialog(state) {
      state.dialog.visible = false
      state.onCrop = null
    },
    reset(state) {
      const initial = initState()
      Object.keys(initial).forEach(key => {
        state[key] = initial[key]
      })
    }
  },

  actions: {}
}
